var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 19,
    viewBox: "0 0 30 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2452 14.0005C20.0636 14.0005 20.874 13.8453 21.6301 13.5438C22.3862 13.2423 23.0732 12.8003 23.6519 12.2431C24.2305 11.686 24.6896 11.0246 25.0028 10.2966C25.3159 9.56865 25.4771 8.78843 25.4771 8.0005C25.4771 7.21257 25.3159 6.43236 25.0028 5.7044C24.6896 4.97645 24.2305 4.31501 23.6519 3.75786C23.0732 3.20071 22.3862 2.75875 21.6301 2.45723C20.874 2.1557 20.0636 2.0005 19.2452 2.0005C17.5924 2.0005 16.0073 2.63264 14.8386 3.75786C13.6699 4.88308 13.0134 6.4092 13.0134 8.0005C13.0134 9.5918 13.6699 11.1179 14.8386 12.2431C16.0073 13.3684 17.5924 14.0005 19.2452 14.0005ZM25.8095 12.9065L29.5279 16.4865C29.627 16.5788 29.706 16.6892 29.7604 16.8113C29.8147 16.9333 29.8433 17.0645 29.8444 17.1973C29.8455 17.3301 29.8191 17.4618 29.7668 17.5846C29.7145 17.7075 29.6373 17.8191 29.5397 17.9129C29.4421 18.0067 29.3261 18.0809 29.1984 18.1311C29.0707 18.1813 28.9339 18.2065 28.796 18.2052C28.6581 18.204 28.5218 18.1763 28.3951 18.1238C28.2685 18.0713 28.1539 17.9951 28.0582 17.8995L24.3398 14.3195C22.6701 15.5674 20.5693 16.1557 18.465 15.9647C16.3606 15.7737 14.411 14.8178 13.0129 13.2916C11.6148 11.7653 10.8734 9.78345 10.9396 7.74943C11.0058 5.7154 11.8747 3.78213 13.3693 2.34315C14.8638 0.904173 16.8718 0.0676701 18.9845 0.00392902C21.0971 -0.0598121 23.1556 0.654 24.7408 2.00005C26.326 3.34611 27.3189 5.22322 27.5172 7.24926C27.7156 9.2753 27.1045 11.298 25.8085 12.9055L25.8095 12.9065Z",
    fill: "#181725"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.399414,
    width: 9.19722,
    height: 2.39923,
    rx: 1.19961,
    fill: "#181725"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.399414,
    y: 7.43823,
    width: 6.71396,
    height: 2.39923,
    rx: 1.19961,
    fill: "#181725"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.399414,
    y: 14.8767,
    width: 9.19722,
    height: 2.39923,
    rx: 1.19961,
    fill: "#181725"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.d2390926cff6b3e77b56e3dbd4aa01c3.svg";
export { ForwardRef as ReactComponent };